import React, { Component, Fragment} from 'react'
import { withRouter } from 'react-router'

import ContactDetails from 'containers/ContactDetails'

class ContactDetailsPage extends Component {
  render() {
    return (
      <Fragment>
        <ContactDetails {...this.props} />
      </Fragment>
    )
  }
}

export default withRouter(ContactDetailsPage)